import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SchoolmanagementService } from '../services/schoolmanagement.service';
import { UseraccessserviceService } from '../services/useraccessservice.service';
import { UtilService } from '../services/util.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {

  constructor(private util: UtilService, private router: Router, private schoolmanager: SchoolmanagementService, private useraccessservice: UseraccessserviceService, private activatedroute: ActivatedRoute) { }

  async ngOnInit() {
    //debugger;
    if(this.activatedroute.snapshot.queryParams.token){
      this.useraccessservice.setAuthenticatedUserToken(this.activatedroute.snapshot.queryParams.token);
    }
        
      //const currentUserToken = this.useraccessservice.getCurrentUserToken();
      // let user;
      // //if(currentUserToken){
      //   user = await this.useraccessservice.isAlive().toPromise().catch(() => {
      //     user = null;
      //   });
      //}
      if(this.useraccessservice.getCurrentUserToken()){//if there is a user logged in
        //go to my courses
        //if you are a admin, go to the school page
        //if you have courses, go to the dashboard
        //else, go to the school page

        //let callerIsAdmin;
        //let studentHasCourses;
        //let tutorHasCourses;
      //   [callerIsAdmin/*, studentHasCourses, tutorHasCourses*/] = await Promise.all([this.util.checkUserIsSubdomainAdmin().toPromise()/*, 
      //                                                           this.util.checkStudentHasCourses().toPromise<boolean>(),
      // this.util.checkTutorHasCourses().toPromise<boolean>()*/]);

      //   if(callerIsAdmin){
      //     this.router.navigate(['/user/schoolhome']);
      //   }
      //   // else if(studentHasCourses || tutorHasCourses) {
      //   //   this.router.navigate(['/user/dashboard']);
      //   // }
      //   else{
      //     this.router.navigate(['/user/dashboard']);
      //   }     

        if (this.activatedroute.snapshot.queryParams.url) {
          this.router.navigateByUrl(this.activatedroute.snapshot.queryParams.url);
        }
        else{
          this.router.navigate(['/user/dashboard']);
        }
      }
      else{
        //debugger;
        // try{
        //   const schoolinfo: any = await this.schoolmanager.getSchoolFromSubdomain().toPromise();
        // }
        // catch(e){
        //   console.error(e);
        // }
        this.router.navigate(['/site/schoolhome']);               
      }
    
  }

}
